import React, { useEffect, useState } from 'react';
import { CheckCircle, XCircle, Info, AlertTriangle, X } from 'lucide-react';
export type ToastType = 'success' | 'error' | 'info' | 'warning';
type ToastProps = {
  message: string;
  type: ToastType;
  onClose: () => void;
  duration?: number;
};
export function Toast({
  message,
  type,
  onClose,
  duration = 5000
}: ToastProps) {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300);
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);
  const icons = {
    success: <CheckCircle className="w-5 h-5 text-green-600" data-id="element-2615" />,
    error: <XCircle className="w-5 h-5 text-red-600" data-id="element-2616" />,
    info: <Info className="w-5 h-5 text-blue-600" data-id="element-2617" />,
    warning: <AlertTriangle className="w-5 h-5 text-yellow-600" data-id="element-2618" />
  };
  const bgColors = {
    success: 'bg-green-50 border-green-200',
    error: 'bg-red-50 border-red-200',
    info: 'bg-blue-50 border-blue-200',
    warning: 'bg-yellow-50 border-yellow-200'
  };
  return <div className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-4 py-3 rounded-xl border-2 shadow-lg transition-all duration-300 ${bgColors[type]} ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-2619">
      {icons[type]}
      <p className="text-sm font-medium text-gray-900" data-id="element-2620">{message}</p>
      <button onClick={() => {
      setIsVisible(false);
      setTimeout(onClose, 300);
    }} className="ml-2 text-gray-500 hover:text-gray-700" data-id="element-2621">
        <X className="w-4 h-4" data-id="element-2622" />
      </button>
    </div>;
}